import {
  Button,
  danger,
  formatNumber,
  Input,
  success,
  sumBy,
  TableSkeleton,
  useEffect,
  useState,
  Badge ,
} from "@";
import { getOrderLines, saveOrderLines } from "../utils/api";
import { editBankTransferTableColumns } from "../utils/options";
import { fillForm } from "../utils/helpers";
import { orderLineTypeColors, orderLineTypeLabels } from "../utils/types";

const OrderDetails = ({ id, paymentType, editSuccess }) => {
  const [data, setData] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);




  // Fetch data state and functions
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data: response } = await getOrderLines(id);
      setData(fillForm(response.data));
    } catch (error) {
      console.log("🚀 ~ fetchData ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle input change
  const handleInputChange = (target, index, value) => {
    if (value < 0 || isNaN(value)) {
      danger("القيمة يجب أن تكون أكبر من صفر");
      return;
    }
    const newData = [...data.orderLines];
    newData[index][target] = value || 0;
    newData[index].totalAmount =
      newData[index].quantity * newData[index].unitAmount;
    setData({ ...data, orderLines: newData });
  };

  // Save edit
  const saveEdit = async () => {
    setIsSaving(true);
    try {
      await saveOrderLines(data?.orderLines, id);
      success("تم حفظ التعديل بنجاح");
      editSuccess();
    } catch (error) {
      danger("حدث خطأ أثناء حفظ التعديل");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <>
      <main className="card p-3">
        {/* Header */}
        <header className="flex-container">
          <label className="text-gray-600 dark:text-gray-400">
            {paymentType === 1 ? "تعديل الحوالة البنكية" : "تفاصيل التبرع"}
          </label>

          {/* Options */}
         {paymentType === 1 && <div className="options-container">
            <Button
              className="py-2 text-sm"
              type="button"
              onClick={saveEdit}
              title="حفظ التعديل"
              isLoading={isSaving}
            />
          </div>}
        </header>

        {/* Table */}
        {!isLoading ? (
          <>
            <div className="relative -mx-3 mt-3">
              <div className="relative overflow-x-auto">
                <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
                  <thead className="border-y bg-gray-100 text-[13px] font-bold text-gray-500 dark:border-gray-700 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      {editBankTransferTableColumns.map((title, index) => (
                        <th
                          key={index}
                          scope="col"
                          className="whitespace-nowrap px-6 py-2.5"
                        >
                          {title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.orderLines?.map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className="border-b bg-white dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400"
                      >
                        <td className="whitespace-nowrap px-6 py-2">
                          {row.projectName}
                        </td>
                        <td className="whitespace-nowrap px-6 py-2">
                          {/* {orderLineTypeLabels[row.orderLineType] || "-"} */}

                          <Badge
                            title={orderLineTypeLabels[row.orderLineType] || "-"}
                            color={orderLineTypeColors[row.orderLineType] || "default"}
                          />
                        </td>
                        <td className="whitespace-now rap px-6 py-2">
                          <Input
                            min="0"
                            style="w-36"
                            type="number"
                            disabled={isSaving || paymentType !== 1}
                            value={row.quantity}
                            change={(e) =>
                              handleInputChange(
                                "quantity",
                                rowIndex,
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="whitespace-nowrap px-6 py-2">
                          <Input
                            min="0"
                            style="w-36"
                            type="number"
                            disabled={isSaving || paymentType !== 1}
                            value={row.unitAmount}
                            change={(e) =>
                              handleInputChange(
                                "unitAmount",
                                rowIndex,
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="whitespace-nowrap px-6 py-2 font-bold">
                          {formatNumber(row.totalAmount)}
                        </td>
                      </tr>
                    ))}
                    <tr className="bg-white text-base font-extrabold dark:bg-gray-800 dark:text-gray-400">
                      <td className="whitespace-nowrap px-6 py-2"></td>
                      <td className="whitespace-nowrap px-6 py-2"></td>
                      <td className="whitespace-nowrap px-6 py-2">الإجمالي</td>
                      <td className="whitespace-nowrap px-6 py-2">
                        {formatNumber(sumBy(data.orderLines, "totalAmount"))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          <TableSkeleton />
        )}
      </main>
    </>
  );
};

export default OrderDetails;
